import { useEffect, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';

import { useSetChatbotQueryResponseState } from 'state/chatbotQueryResponseState';
import { useSetConversationEffect } from 'state/conversation';

export const useSetChatbotQueryResponseStateEffect = (queryResponse) => {
  const setChatbotQueryResponse = useSetChatbotQueryResponseState();

  useEffect(() => {
    if (!isEmpty(queryResponse)) {
      setChatbotQueryResponse(queryResponse);
    }
  }, [setChatbotQueryResponse, queryResponse]);
};

export const useChatbotQueryResponseEffect = (queryResponse) => {
  useSetChatbotQueryResponseStateEffect(queryResponse);
  useSetConversationEffect(queryResponse);
};

export const useChatbotInitialQuerySetConversationEffect = (
  initialQueryResponse,
  shouldPushToConversation,
) => {
  const pushToConversationQueryRef = useRef();

  if (!isEmpty(initialQueryResponse) && shouldPushToConversation) {
    pushToConversationQueryRef.current = initialQueryResponse;
  }

  useSetConversationEffect(pushToConversationQueryRef.current);
};
